export const loginRoutes = {
  root: `/login`,
};
